import { APP_INITIALIZER, ErrorHandler, NgModule } from "@angular/core";
import { Router } from "@angular/router";
import * as Sentry from "@sentry/angular-ivy";
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './@shared/shared.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AuthGuard } from './auth/guard';
import { PusherService } from './@shared/services/pusher.service';
import { AfterLoginPopupComponent } from './layout/after-login-popup/after-login-popup.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { GeneralConfigService } from "./@shared/services/general-config.service";
import { environment } from "src/environments/environment";

@NgModule({
  declarations: [
    AppComponent,
    AfterLoginPopupComponent
  ],
  imports: [
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    TooltipModule.forRoot(),
    BsDatepickerModule.forRoot()
  ],
  providers: [AuthGuard,PusherService,
    GeneralConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInit,
      multi: true,
      deps: [GeneralConfigService]
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    }, {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function appInit(appConfigService: GeneralConfigService) {
  // let config = appConfigService.load();
  // config.then((value: any) => {
  //   environment.isMobile = value;

  // })

  // return () => config;
  let envConfig = appConfigService.load();
  envConfig.then((value: any) => {    
    environment.isMobile = value;
  })

  return () => envConfig;
}
